import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { filter, Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { UserState } from '../states/user.state';
import { USER_ROLES } from '../enums/UserRoles.enum';

@Injectable({
  providedIn: 'root',
})
export class RolePermissionGuard {
  private router = inject(Router);
  private store = inject(Store);
  private userRole$: Observable<USER_ROLES> = this.store.select<USER_ROLES>(UserState.userRole);

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.userRole$.pipe(
      filter((userRole: USER_ROLES) => !!userRole),
      map((userRole: USER_ROLES) => this.checkUserLogin(next, userRole)),
    );
  }

  private checkUserLogin(route: ActivatedRouteSnapshot, userRole: USER_ROLES): boolean {
    if (route.data.roles && route.data.roles.length) {
      if (route.data.roles.includes(userRole)) {
        return true;
      }
      return this.denyRouteActivationAndNavigateToHome();
    }
    return this.denyRouteActivationAndNavigateToHome();
  }

  private denyRouteActivationAndNavigateToHome(): boolean {
    void this.router.navigate(['/home']);
    return false;
  }
}
